function shallowCompareArrays(a: any[] | null, b: any[] | null): boolean {
  if (a === b)
    return true;

  if (a == null || b == null)
    return a === b;

  if (a.length !== b.length)
    return false;

  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i])
      return false;
  }

  return true;
}


export default function memoize<F extends Function>(func: F): F {
  let prevArgs: any[] | null = null;
  let prevResult: any = null;

  const memoized: any = (...args: any[]) => {
    if (shallowCompareArrays(prevArgs, args))
      return prevResult;

    const result = func(...args);
    prevArgs = args;
    prevResult = result;

    return result;
  };

  return memoized as F;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/utils/memoize.ts